module.exports = __webpack_public_path__ + "img/bridge.8008b196.png";